import { defineFcm } from '../shared/factory';

export const FCM_CORAL_COMMENT_LIKE_EMAIL_ENABLED = defineFcm('coral_comment_like_email_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description: 'Flag to enable/disable the email notification for comment likes.',
		import: false,
	});
